var map = {
	"./ar/document-create": 72805,
	"./de/document-create": 88477,
	"./en/document-create": 51477,
	"./es/document-create": 7426,
	"./fr/document-create": 65722,
	"./ja/document-create": 94715,
	"./ko/document-create": 25828,
	"./pt/document-create": 46154,
	"./zh/document-create": 71076,
	"./zh_HANT/document-create": 45930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76735;